module.exports = __webpack_public_path__ + "img/modal-document-error-fl.64f090af.svg";